import { transformErrorResponse } from "../../../shared/oversight-core/utils/transformErrorResponse";
import { rootApi } from "../apiManager";

export type ClaimAvailability = "USABLE" | "ALREADY_CLAIMED" | "NOT_USABLE";

export interface IPreviewClaimResponseDTO {
  availability: ClaimAvailability;
  // Only set when the code is usable.
  firstName: string | null;
  channel: "EMAIL" | "SMS" | null;
  maskedDestination: string | null;
  expiresAt: string | null;
}

export interface ICompleteClaimResponseDTO {
  verifiedChannel: "EMAIL" | "SMS";
}

export const claimAPI = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    previewClaim: builder.mutation<IPreviewClaimResponseDTO, { code: string }>({
      transformErrorResponse,
      query(body) {
        return { url: "user/claim/preview", method: "POST", body };
      },
    }),
    completeClaim: builder.mutation<
      ICompleteClaimResponseDTO,
      { code: string; password: string }
    >({
      transformErrorResponse,
      query(body) {
        return { url: "user/claim", method: "POST", body };
      },
    }),
  }),
});

export const { usePreviewClaimMutation, useCompleteClaimMutation } = claimAPI;
